import React from "react";
import PropTypes from "prop-types";
import cx from "clsx";
import { useClinicsQuery } from "../../../../../api/queries/useClinicsQuery";
import { Select } from "../../../../../shared/Select/Select";
import classes from "./PosClinicFilter.module.scss";

export function PosClinicFilter({
  isClinicConnection,
  value,
  onChange,
  className,
}) {
  const { data, isLoading } = useClinicsQuery({
    enabled: isClinicConnection,
  });

  if (!isClinicConnection) {
    return null;
  }

  const options = (data || []).map((clinic) => ({
    label: clinic.name,
    value: clinic.id,
  }));

  return (
    <div className={cx(classes.root, className)}>
      <Select
        size="small"
        isSearchable
        isClearable
        isFixed
        placeholder="All Clinics"
        options={options}
        value={options.find((option) => option.value === value) || null}
        onChange={(option) => onChange(option ? option.value : "")}
        isLoading={isLoading}
      />
    </div>
  );
}

PosClinicFilter.propTypes = {
  isClinicConnection: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

PosClinicFilter.defaultProps = {
  value: "",
  className: "",
};
